<script>
export default {
  name: 'logo',
  props: {
    color: { default: 'teal' },
    stroke: { default: 'black' },
    strokeWidth: { default: 10 },
    height: { default: 100 },
    width: { default: 100 }
  }
}
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 900 900"
  >

    <g
      :fill="color"
      :stroke="stroke"
      :stroke-width="strokeWidth"
      transform="translate(0,900) scale(0.1,-0.1)"
    >
      <path d="M4750 7805 l0 -55 1215 0 1215 0 0 55 0 55 -1215 0 -1215 0 0 -55z" />
      <path d="M7465 7724 c-22 -13 -39 -28 -38 -33 2 -9 1144 -2059 1169 -2098 l14
-22 45 26 46 25 -24 42 c-13 22 -277 496 -587 1051 -309 556 -568 1015 -574
1021 -8 8 -22 5 -51 -12z" />
      <path d="M4366 7617 c-41 -67 -324 -534 -630 -1037 l-555 -914 42 -28 c23 -15
45 -24 49 -20 6 6 1229 2017 1248 2053 7 11 -2 21 -35 41 l-44 27 -75 -122z" />
      <path d="M1532 5695 c-61 -27 -94 -58 -118 -109 -31 -67 -30 -119 3 -185 19
-39 23 -58 16 -70 -5 -9 -195 -320 -422 -692 l-412 -677 -41 -5 c-106 -14
-194 -120 -186 -223 9 -109 91 -190 204 -203 l55 -6 425 -763 425 -764 -39
-38 c-110 -106 -86 -272 48 -343 46 -24 64 -28 112 -25 86 6 145 47 183 126
l30 61 875 0 875 0 30 -61 c24 -50 40 -68 79 -93 42 -25 59 -30 116 -30 91 0
153 37 193 114 46 92 28 186 -49 257 l-37 33 176 288 c96 158 306 502 465 763
l290 475 52 6 c117 15 206 117 198 226 -7 76 -49 139 -118 176 -49 26 -62 28
-120 24 l-65 -5 -398 716 -398 716 16 38 c22 57 19 107 -12 169 -78 152 -293
159 -378 11 l-30 -51 -875 -1 -875 0 -25 47 c-48 90 -179 138 -268 98z m2063
-287 c24 -49 40 -69 78 -92 64 -39 137 -46 200 -18 44 19 48 20 56 4 601
-1071 778 -1398 766 -1412 -26 -29 -55 -105 -55 -145 0 -53 32 -120 75 -159
l34 -31 -467 -767 -467 -766 -46 -4 c-69 -7 -134 -49 -167 -108 l-27 -50 -885
0 -885 0 -27 50 c-33 59 -98 101 -168 108 l-49 4 -412 742 c-226 407 -419 753
-427 768 -15 26 -14 28 16 56 41 38 71 106 72 158 0 54 -44 140 -86 167 -19
12 -34 26 -34 31 0 4 185 312 411 682 376 617 413 674 433 667 11 -5 48 -8 82
-8 89 0 148 39 189 123 l30 61 865 0 865 0 30 -61z" />
      <path d="M3305 5394 c-22 -13 -39 -28 -38 -34 3 -9 1144 -2057 1169 -2097 l14
-22 45 26 46 25 -24 42 c-14 22 -278 496 -587 1051 -309 556 -568 1015 -574
1021 -8 8 -22 5 -51 -12z" />
      <path d="M8594 5388 c-5 -7 -289 -474 -631 -1038 l-622 -1024 42 -28 c23 -15
45 -24 49 -20 3 4 288 470 632 1036 557 917 623 1031 608 1041 -63 43 -70 46
-78 33z" />
      <path d="M4750 3095 l0 -55 1215 0 1215 0 0 55 0 55 -1215 0 -1215 0 0 -55z" />
    </g>
  </svg>
</template>


// WEBPACK FOOTER //
// src/components/logo.vue